module.exports = __webpack_public_path__ + "fonts/roboto-v30-latin-regular.6b1ef4e.ttf";